<!-- --start here -->

<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-12 col-md-10 col-lg-9">

      <!-- <h3 class="mb-4 text-center font-semibold text-lg text-gray-800 bg-dark-gray-100">
        {{ 'CREATE USER LOGIN FOR NEW USER' | translate }}
      </h3> -->

      <div class="card border border-light-subtle rounded-4 shadow-sm overflow-auto">
 <h3 class="mb-4 text-center font-semibold text-lg text-gray-800 bg-dark-gray-100">
        {{ 'Create User Login For New User' | translate }}
      </h3>

        <div class="card-body gradient-bg rounded-3xl p-4 p-md-5 shadow-lg bg-dark-gray-100">

          <!-- 🔹 Officer Form -->
          <form [formGroup]="officerForm" class="w-full mb-5">
            <div class="flex flex-wrap gap-3 items-end">
              <div class="flex-1 min-w-[180px]">
                <label class="block text-sm font-medium mb-1 text-gray-700">
                  {{ 'Officer Name' | translate }}
                </label>
                <input type="text" pInputText formControlName="officerName"
                       placeholder="{{ 'Enter Officer Name' | translate }}"
                       class="w-full h-[36px] px-3"/>
              </div>

              <div class="flex-1 min-w-[200px]">
                <label class="block text-sm font-medium mb-1 text-gray-700">
                  {{ 'Email Id' | translate }}
                </label>
                <input type="email" pInputText formControlName="emailId"
                       placeholder="{{ 'Enter Email' | translate }}"
                       class="w-full h-[36px] px-3"/>
              </div>

              <div class="flex-1 min-w-[150px]">
                <label class="block text-sm font-medium mb-1 text-gray-700">
                  {{ 'Mobile Number' | translate }}
                </label>
                <input type="text" pInputText formControlName="mobile"
                       placeholder="{{ 'Enter Mobile Number' | translate }}"
                       class="w-full h-[36px] px-3"/>
              </div>

              <div class="flex-1 min-w-[120px] flex items-end justify-center md:justify-end">
                <button pButton pRipple type="button" label="Next"  icon="pi pi-arrow-right"
                        class="p-button-primary small-btn"
                        (click)="storeOfficerData()">
                </button>
              </div>
            </div>
          </form>

       <!-- 🔹 Login Dialog -->
<p-dialog
  [(visible)]="showLoginPanel"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [baseZIndex]="11000"
  [style]="{ width: '80vw', maxWidth: '1300px' }"
  [breakpoints]="{ '960px': '95vw', '640px': '98vw' }"
  header="User Geo Mapping">

  <div class="p-4 max-h-[80vh] overflow-y-auto">

    <!-- 🔸 Login Form -->
   <!-- 🔸 Login Form -->
<form [formGroup]="loginForm" class="w-full mb-6">
 <div class="flex flex-wrap gap-6 justify-center items-end">
  <!-- Role -->
  <div class="flex-1 min-w-[200px]">
    <label class="block text-sm font-medium mb-1">{{ 'Role Type' | translate }}</label>
    <select
      formControlName="roleID"
      (change)="filterActionsByRole()"
      class="w-full p-2 border border-gray-300 rounded-md"
    >
      <option value="">{{ 'Select Role' | translate }}</option>
      <option *ngFor="let role of roles" [value]="role.roleID">
        {{ role.user_Role }}
      </option>
    </select>
  </div>

  <!-- District -->
  <div class="flex-1 min-w-[200px]">
    <label class="block text-sm font-medium mb-1">{{ 'District' | translate }}</label>
    <select
      formControlName="districtID"
      (change)="onDistrictChangeEvent()"
      class="w-full p-2 border border-gray-300 rounded-md"
    >
      <option value="">{{ 'Select District' | translate }}</option>
      <option *ngFor="let d of districts" [value]="d.Dist_Code">
        {{ d.District }}
      </option>
    </select>
  </div>

  <!-- Office Order Upload -->
  <div class="flex-1 min-w-[200px]">
    <label class="block text-sm font-medium mb-1 text-gray-700">
      {{ 'Office Order' | translate }} <span class="text-red-500 ml-1">*</span>
    </label>

    <div class="flex items-center gap-2">
      <!-- Upload button -->
      <p-fileUpload
        #fileUploader
        mode="basic"
        name="officeOrder"
        chooseLabel="Upload Office Order"
        [auto]="false"
        [customUpload]="true"
        (onSelect)="onFileUpload($event)"
        accept=".pdf,.jpg,.jpeg,.png"
        class="!p-0 !m-0 flex-1"
      ></p-fileUpload>

      <!-- Show icons if a file is uploaded -->
      <div *ngIf="uploadedFile" class="flex items-center space-x-1">
        <button
          pButton
          icon="pi pi-eye"
          class="p-button-rounded p-button-text p-button-info"
          (click)="viewFile()"
          title="View File"
        ></button>

        <button
          pButton
          icon="pi pi-times"
          class="p-button-rounded p-button-text p-button-danger"
          (click)="removeUploadedFile()"
          title="Remove File"
        ></button>
      </div>
    </div>
  </div>
</div>

</form>


<!-- ✅ Message for Role 8 -->
<div *ngIf="showActionOnlyMessage"
     class="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 p-3 rounded mb-3">
  ⚠️ You can only select Action Below. District mapping is fixed For XEN.
</div>
    <!-- 🔸 Geo Mapping Accordion -->
    <div class="mapping-section mt-4">
      <p-accordion class="w-full mapping-section">
        <p-accordionTab header="Assign Geo Mapping" [(selected)]="isGeoAccordionOpen">

          <div class="overflow-x-auto">
            <table class="min-w-full border border-gray-200 rounded-lg">
              <thead class="bg-gray-100 text-gray-700">
                <tr>
                  <th class="px-3 py-2 text-left border">S.No</th>
                  <th class="px-3 py-2 text-left border">Mapping Type</th>
                  <th class="px-3 py-2 text-left border">District</th>
                  <th class="px-3 py-2 text-left border">Block</th>
                  <th class="px-3 py-2 text-left border">Village</th>
                  <th class="px-3 py-2 text-left border">Action</th>
                  <th class="px-3 py-2 text-center border">Add</th>
                  <th class="px-3 py-2 text-center border">Remove</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let row of geoMappings; let i = index" class="hover:bg-gray-50">
                  <td class="px-3 py-2 border text-center">{{ i + 1 }}</td>

                  <td class="px-2 py-2 border">
                    <select [(ngModel)]="row.mappingType" (change)="onMappingTypeChange(row)" [disabled]="isDistrictLocked" class="dropdown-style">
                      <option value="">Select Type</option>
                      <option value="District">District</option>
                      <option value="Block">Block</option>
                      <option value="Village">Village</option>
                    </select>
                  </td>

                  <td class="px-2 py-2 border">
                    <select [(ngModel)]="row.districtID" [disabled]="!row.enableDistrict"
                            (change)="onDistrictChange(row)" class="dropdown-style">
                      <option value="">Select District</option>
                      <option *ngFor="let d of districts" [value]="d.Dist_Code">{{ d.District }}</option>
                    </select>
                  </td>

                  <td class="px-2 py-2 border">
                    <select [(ngModel)]="row.blockID" [disabled]="!row.enableBlock"
                            (change)="onBlockChange(row)" class="dropdown-style">
                      <option value="">Select Block</option>
                      <option *ngFor="let b of row.blocks" [value]="b.Block_Code">{{ b.Block }}</option>
                    </select>
                  </td>

                  <td class="px-2 py-2 border">
                    <select [(ngModel)]="row.villageID" [disabled]="!row.enableVillage" class="dropdown-style">
                      <option value="">Select Village</option>
                      <option *ngFor="let v of row.villages" [value]="v.Vill_Code">{{ v.Village }}</option>
                    </select>
                  </td>

                  <td class="px-2 py-2 border">
                    <select [(ngModel)]="row.actionID" class="dropdown-style">
                    <option value="" disabled selected>Select Action</option>
                      <option *ngFor="let act of filteredActions" [value]="act.actionID">{{ act.action }}</option>
                    </select>
                  </td>

                  <td class="px-2 py-2 border text-center">
                    <button pButton icon="pi pi-plus"
                            class="p-button-success p-button-rounded"
                            (click)="addGeoMappingRow()"></button>
                  </td>
                  <td class="px-2 py-2 border text-center">
                    <button pButton icon="pi pi-trash"
                            class="p-button-danger p-button-rounded"
                            (click)="removeGeoMapping(i)"></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="flex justify-center mt-6 gap-4">
            <button pButton label="Submit All"
                    icon="pi pi-check"
                    class="p-button-primary px-6 py-2"
                    (click)="submitGeoMappings()">
            </button>

            <!-- <button pButton label="Close"
                    icon="pi pi-times"
                    class="p-button-secondary px-6 py-2"
                    (click)="closeDialog()">
            </button> -->
          </div>

          <!-- ✅ Success message section -->
          <!-- <div *ngIf="newUserID" class="text-center mt-4">
            <p class="text-green-600 font-semibold text-lg">
              ✅ User Created Successfully: {{ newUserID }}
            </p>
          </div> -->

        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
</p-dialog>


        </div>
      </div>
    </div>
  </div>
</div>

<!-- ✅ Success Dialog -->
<p-dialog
  [(visible)]="showSuccessDialog"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  header="User Created Successfully"
  [style]="{ width: '400px' }"
>
  <div class="text-center p-4">
    <!-- <p class="text-lg font-semibold text-green-600">
      ✅ User ID Generated Successfully
    </p> -->
    <p class="mt-2 text-gray-800">
      <strong>User ID:</strong> {{ newUserID }}
    </p>

    <button
      pButton
      label="Close"
      icon="pi pi-times"
      class="mt-4 p-button-rounded p-button-primary"
      (click)="closeAllDialogs()"
    ></button>
  </div>
</p-dialog>



<p-dialog [(visible)]="showEditModal" [modal]="true" [closable]="true"
          [style]="{ width: '100%', 'max-width': '700px' }" [baseZIndex]="10000"
          [header]="
            ' ' + (editedUser?.userID || '-') + ' (' + (editedUser?.editMode ? 'Active' : 'Inactive') + ')'
          "
          headerStyleClass="bg-gray-100 text-center font-semibold text-lg">

  <!-- 🔹 Buttons Row -->
  <div class="flex justify-between gap-2 mt-4 w-full">
   

    <button (click)="openMappingModal(editedUser)" pButton pRipple
    label="{{'Edit Mapping' | translate}}" icon="pi pi-map"
    class="p-button-help"
    style="height: 2.5rem; font-size: 0.9rem;"></button>

  

    <button (click)="confirmDeactivate(editedUser)" [disabled]="!editedUser?.editMode" pButton pRipple
    label="{{'Disabled Mapping' | translate}}" icon="pi pi-ban"
    class="p-button-danger"
    style="height: 2.5rem; font-size: 0.9rem;"></button>

 

    <button (click)="openContactModal(editedUser)" [disabled]="!editedUser?.editMode" pButton pRipple
    label="{{'Contact Details' | translate}}" icon="pi pi-user-edit"
    class="p-button-warning"
    style="height: 2.5rem; font-size: 0.9rem;"></button>



    <button (click)="setSelectedUser(editedUser)" [disabled]="!editedUser?.editMode" pButton pRipple
    label="{{'Unlock User' | translate}}" icon="pi pi-unlock"
    class="p-button-success"
    style="height: 2.5rem; font-size: 0.9rem;"></button>
  </div>

</p-dialog>






<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-12 col-md-10 col-lg-11">

  
      


 <p-card styleClass="p-card-shadow" class="dashboardTable">
  <h3 class="text-center font-semibold text-lg text-gray-800 bg-dark-gray-100 py-2 rounded-top mb-3">
          {{ 'User Geo Mapping Details' | translate }}
        </h3>


 <p-table
  [value]="filteredGeoMappings"
  [rows]="10"
  [paginator]="true"
  [loading]="loading"
  [rowHover]="true"
  responsiveLayout="scroll"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  styleClass="p-datatable-gridlines"
  [tableStyle]="{ 'max-width': '95rem' }"
  class="custom-geo-table"
>

  <ng-template pTemplate="caption">
    <div class="flex justify-content-end items-center gap-2">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input
          type="text"
          pInputText
          [(ngModel)]="searchUserId"
          (input)="filterByUserId()"
          placeholder="Search by User ID"
        />
      </span>
    </div>
  </ng-template>

<!--    
    <ng-template pTemplate="header">
      <tr>
        <th>S.No</th>
        <th>User ID</th>
        <th>User Role</th>
        <th>Officer Name</th>
        <th>Mobile</th>
        <th>Email</th>
        <th>Action</th>
        <th>Area Type</th>
        <th>Area</th>
        <th>Actions</th>
      </tr>
    </ng-template> -->
<ng-template pTemplate="header">
  <tr style="background-color:#374151; color:white; text-align:center;">
    <th pSortableColumn="sno">S.No <p-sortIcon field="sno"></p-sortIcon></th>
    <th pSortableColumn="userID">User ID <p-sortIcon field="userID"></p-sortIcon></th>
    <th pSortableColumn="userRole">User Role <p-sortIcon field="userRole"></p-sortIcon></th>
    <th pSortableColumn="officerName">Officer Name <p-sortIcon field="officerName"></p-sortIcon></th>
    <th pSortableColumn="mobile">Mobile <p-sortIcon field="mobile"></p-sortIcon></th>
    <th pSortableColumn="email">Email <p-sortIcon field="email"></p-sortIcon></th>
    <th pSortableColumn="action">Action <p-sortIcon field="action"></p-sortIcon></th>
    <th pSortableColumn="areaType">Area Type <p-sortIcon field="areaType"></p-sortIcon></th>
    <th pSortableColumn="area">Area <p-sortIcon field="area"></p-sortIcon></th>
    <th>Actions</th>
  </tr>
</ng-template>

  
    <ng-template pTemplate="body" let-user let-ri="rowIndex">
      <tr [ngClass]="{ 'row-edit-mode': user.editMode }"   [ngStyle]="{
      'background-color': getGeoRowColor(user.geoType),
      color: 'black'
    }">
        <td>{{ ri + 1 }}</td>
        <td>{{ user.userID }}</td>
        <td>{{ user.userType }}</td>
        <td>{{ user.officer_Name }}</td>
        <td>{{ user.mobile }}</td>
        <td>{{ user.emailID }}</td>
        <!-- //<td>{{ getActionName(user.actionID) }}</td> -->
         <td>{{user.action}}</td>
           <!-- Area Type with colored block -->
     
        <td>{{ user.geoType }}</td>
        <td>{{ user.geoName }}</td>

        <td class="flex gap-2">
        
          <button *ngIf="!user.editMode" pButton icon="pi pi-pencil" class="p-button-rounded p-button-warning"
            (click)="toggleEdit(user)" pTooltip="Edit User"></button>

        
          <div *ngIf="user.editMode" class="flex gap-2">


      
            <button pButton icon="pi pi-times" class="p-button-rounded p-button-secondary" (click)="toggleEdit(user)"
              pTooltip="Cancel Edit"></button>
          </div>
        </td>
      </tr>
    </ng-template>

 
    <ng-template pTemplate="summary">
      <p>Total Records: {{ geoMappingResults?.length || 0 }}</p>
    </ng-template>


  <!-- Table Summary with legend -->
  <ng-template pTemplate="summary">
    <div class="flex align-items-center justify-content-between text-sm">
      <div>
        Total Records: <strong>{{ geoMappingResults?.length || 0 }}</strong>
      </div>
      <div class="flex gap-3">
        <div class="flex align-items-center gap-1">
          <div style="background-color:#ffcccc; width:20px; height:20px; border-radius:5px;"></div>
          District
        </div>
        <div class="flex align-items-center gap-1">
          <div style="background-color:#cce5ff; width:20px; height:20px; border-radius:5px;"></div>
          Block
        </div>
        <div class="flex align-items-center gap-1">
          <div style="background-color:#ccffcc; width:20px; height:20px; border-radius:5px;"></div>
          Village
        </div>
        <div class="flex align-items-center gap-1">
          <div style="background-color:#e6f7ff; width:20px; height:20px; border-radius:5px;"></div>
          Other
        </div>
      </div>
    </div>
  </ng-template>


  </p-table>
</p-card>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>


  <p-dialog
  header="Update Contact Info"
  [(visible)]="showContactModal"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '50rem' }"
  [baseZIndex]="10000"
>
  <div *ngIf="selectedUser" class="p-fluid">

    
    <div class="field mb-3">
      <label>User ID:</label>
      <input
        type="text"
        pInputText
        [(ngModel)]="selectedUser.userID"
        readonly
        class="readonly-input"
      />
    </div>


    <div class="field mb-3">
      <label>Choose what to update:</label>
      <p-dropdown
        [options]="updateOptions"
        [(ngModel)]="selectedUpdateType"
        (onChange)="onUpdateTypeChange($event.value)"
        optionLabel="label"
        optionValue="value"
        placeholder="Select Option"
        appendTo="body"
        styleClass="custom-dropdown"
      ></p-dropdown>
    </div>

    <div class="field mb-3">
      <label>Mobile:</label>
      <input
        type="text"
        pInputText
        [(ngModel)]="selectedUser.mobile"
        [readonly]="
          !selectedUpdateType ||
          selectedUpdateType === 'email'
        "
        [ngClass]="{
          'readonly-input':
            !selectedUpdateType ||
            selectedUpdateType === 'email'
        }"
      />
    </div>

   
    <div class="field mb-3">
      <label>Email:</label>
      <input
        type="email"
        pInputText
        [(ngModel)]="selectedUser.emailID"
        [readonly]="
          !selectedUpdateType ||
          selectedUpdateType === 'mobile'
        "
        [ngClass]="{
          'readonly-input':
            !selectedUpdateType ||
            selectedUpdateType === 'mobile'
        }"
      />
    </div>

   
    <div class="flex justify-end gap-2 mt-4">
      <button
        pButton
        label="Cancel"
        class="p-button-secondary"
        (click)="showContactModal = false"
      ></button>
      <button
        pButton
        label="Update"
        class="p-button-success"
        (click)="updateContactInfo()"
        [disabled]="!selectedUpdateType"
      ></button>
    </div>
  </div>
</p-dialog>





<p-dialog header="Register User Mapping - {{ mappingUserID }}" [(visible)]="showMappingModal"
[modal]="true" [closable]="true" [style]="{ width: '90vw', maxWidth: '1200px' }" [baseZIndex]="10000">
<div class="p-4">

   

<div class="overflow-x-auto">
<table class="min-w-full border border-gray-200 rounded-lg">
<thead class="bg-gray-100 text-gray-700">
<tr>
  <th class="px-3 py-2 text-left border">S.No</th>
  <th class="px-3 py-2 text-left border">User ID</th>
  <th class="px-3 py-2 text-left border">Mapping Type</th>
  <th class="px-3 py-2 text-left border">District</th>
  <th class="px-3 py-2 text-left border">Block</th>
  <th class="px-3 py-2 text-left border">Village</th>
  <th class="px-3 py-2 text-left border">Action</th>
  <th class="px-3 py-2 text-center border">Add</th>
  <th class="px-3 py-2 text-center border">Remove</th>
</tr>
</thead>

<tbody>
<tr *ngFor="let row of geoMappings; let i = index" class="hover:bg-gray-50">
  <td class="px-3 py-2 border text-center">{{ i + 1 }}</td>


  <td class="px-3 py-2 border text-center">{{ mappingUserID || '-' }}</td>


  <td class="px-2 py-2 border">
    <select [(ngModel)]="row.mappingType" (change)="onMappingTypeChange(row)" class="dropdown-style">
      <option value="">Select Type</option>
      <option value="District">District</option>
      <option value="Block">Block</option>
      <option value="Village">Village</option>
    </select>
  </td>

  <td class="px-2 py-2 border">
    <select [(ngModel)]="row.districtID" [disabled]="!row.enableDistrict"
            (change)="onDistrictChange(row)" class="dropdown-style">
      <option value="">Select District</option>
      <option *ngFor="let d of districts" [value]="d.Dist_Code">{{ d.District }}</option>
    </select>
  </td>

  <td class="px-2 py-2 border">
    <select [(ngModel)]="row.blockID" [disabled]="!row.enableBlock"
            (change)="onBlockChange(row)" class="dropdown-style">
      <option value="">Select Block</option>
      <option *ngFor="let b of row.blocks" [value]="b.Block_Code">{{ b.Block }}</option>
    </select>
  </td>

 
  <td class="px-2 py-2 border">
    <select [(ngModel)]="row.villageID" [disabled]="!row.enableVillage" class="dropdown-style">
      <option value="">Select Village</option>
      <option *ngFor="let v of row.villages" [value]="v.Vill_Code">{{ v.Village }}</option>
    </select>
  </td>


    <td class="px-2 py-2 border"> <select [(ngModel)]="row.actionID" class="dropdown-style"> 
      <option value="">Select Action</option> <option *ngFor="let act of getAllActions()" [value]="act.actionID"> {{ act.action }} 

      </option> 
    </select> </td>

  <td class="px-2 py-2 border text-center">
    <button pButton icon="pi pi-plus" class="p-button-success p-button-rounded"
            (click)="addGeoMappingRow()"></button>
  </td>

 
  <td class="px-2 py-2 border text-center">
    <button pButton icon="pi pi-trash" class="p-button-danger p-button-rounded"
            (click)="removeGeoMapping(i)"></button>
  </td>
</tr>
</tbody>
</table>
</div>


<div class="flex justify-center mt-6">
<button pButton label="Submit Mappings" icon="pi pi-check" class="p-button-primary px-6 py-2"
    (click)="submitGeoMappingsForRegisterUser()"></button>
</div>

</div>
</p-dialog>


  <p-dialog
  header="🔓 Unlock Account"
  [(visible)]="showUnlockModal"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '40rem', 'max-width': '95vw' }"
>
  <div *ngIf="selectedUserLockout" class="p-4">

    <!-- 🧾 User Info Table -->
    <table class="w-full border border-gray-300 rounded-md overflow-hidden">
      <tr class="bg-green-50">
        <th class="px-3 py-2 text-left w-1/3 border border-gray-200 font-medium text-gray-700">
          User ID
        </th>
        <td class="px-3 py-2 border border-gray-200 text-gray-800">
          {{ selectedUserLockout.userID }}
        </td>
      </tr>

      <tr>
        <th class="px-3 py-2 text-left border border-gray-200 font-medium text-gray-700">
          Officer Name
        </th>
        <td class="px-3 py-2 border border-gray-200 text-gray-800">
          {{ selectedUserLockout.officer_Name }}
        </td>
      </tr>

      <tr class="bg-green-50">
        <th class="px-3 py-2 text-left border border-gray-200 font-medium text-gray-700">
          Lockout Enabled
        </th>
        <td class="px-3 py-2 border border-gray-200 text-gray-800">
          {{ selectedUserLockout.lockoutEnabled }}
        </td>
      </tr>

      <tr>
        <th class="px-3 py-2 text-left border border-gray-200 font-medium text-gray-700">
          Lockout End
        </th>
        <td class="px-3 py-2 border border-gray-200 text-gray-800">
          {{ selectedUserLockout.lockoutEnd | date: 'short' }}
        </td>
      </tr>
    </table>

    <div class="grid grid-cols-2 gap-3 mt-5">
      <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-secondary w-full py-3 text-base"
        (click)="showUnlockModal = false"
      ></button>

      <button
        pButton
        type="button"
        label="Unlock"
        class="p-button-success w-full py-3 text-base"
        (click)="unlockUser()"
      ></button>
    </div>

  </div>
</p-dialog>

<!-- </section> -->
      
    
    </div>
  </div>
</div>


